import axios from "axios";
import { API_URL } from "../../../setup/config/env";

export const createOrUpdateQrTable = async(payload)=>{
    try{
        const response = await axios.post(`${API_URL}/api/qrDining/createOrUpdate`, payload, {
            headers:{
                "Content-type":"application/json"
            }
        })
        return response.data
    }
    catch(error){
        console.error("Error creating QR Table: ", error)
        throw error
    }
}

export const toggleQrTableStatus = async(id, isActive)=>{
    try{
        const response = await axios.post(`${API_URL}/api/qrDining/toggle-status`, {id, isActive}, {
            headers:{
                "Content-type":"application/json"
            }
        })
        return response.data
    }
    catch(error){
        console.error("Error toggling QR Table Status: ", error)
        throw error
    }
}

export const deleteQrTable = async(id)=>{
    try{
        const response = await axios.post(`${API_URL}/api/qrDining/delete`, {_id: id}, {
            headers:{
                "Content-type":"application/json"
            }
        })
        return response.data
    }
    catch(error){
        console.error("Error deleting QR Table: ", error)
        throw error
    }
}